/* eslint-disable import/no-named-as-default */
import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons/faGlobeAmericas';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';

import Notifications from '@/components/layout/Notifications';
import Routes from '@/components/Routes';

import AppInitializer from './AppInitializer';

import AppInsights from './tracking/AppInsights';
import Clarity from './tracking/Clarity';

import GlobalStyle from '@/styles/GlobalStyles';
import FallbackProvider from './FallbackProvider';
import ErrorBoundary from './tracking/ErrorBoundary';

import { queryClient } from '@/config/queryClient';

library.add(faGlobeAmericas, faPen);

const App = () => (
  <>
    <AppInsights />
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <FallbackProvider>
          <Notifications />
          {/* @ts-ignore */}
          <AppInitializer>
            <GlobalStyle />
            {/* @ts-ignore */}
            <Clarity debug />
            <Routes />
          </AppInitializer>
        </FallbackProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </>
);

App.propTypes = {
  children: PropTypes.element,
};

export default App;
